export default __webpack_public_path__ + "static/media/right_side_facing_camera.f9a53a9f.mp3";